import { CogStopIcon } from './CogStopIcon';

/**
 * author: Michael Irigoyen
 * id FC49E1B1-ED0E-46CB-B29F-ED444E9B85F0
 * name cog-stop
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cog-stop.svg
 * tags
 * - Settings 
 */
export const GearStopIcon = CogStopIcon;
export default GearStopIcon